import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ChangeUserPasswordModel } from 'src/app/models/user/changeUserPassword.model';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-change-user-password',
  templateUrl: './change-user-password.component.html',
  styleUrls: ['./change-user-password.component.css']
})
export class ChangeUserPasswordComponent implements OnInit {
  changeUserPassword: ChangeUserPasswordModel;
  Loader: boolean = false;
  userSub: Subscription;
  userId: string;

  constructor(private localstorage: LocalstorageService, private _userService: UserService, private alertify: AlertifyService, private router: Router, private modalService: NgbModal) {
    this.localstorage.setMenu("2");
    this.changeUserPassword = new ChangeUserPasswordModel();
  }

  ngOnInit() {
    this.userSub = this._userService.getUserId.subscribe((userId) => {
      this.userId = userId;
    });
  }

  onCancel() {
    this.modalService.dismissAll();
  }

  ngOnDestroy() {
    this.userSub.unsubscribe();
  }

  onSubmit(): void {
    if (this.changeUserPassword.Password == undefined || this.changeUserPassword.Password == null || this.changeUserPassword.Password == "") {
      this.alertify.error("Password is required");
      return;
    }
    this.Loader = true;
    this.changeUserPassword.Id = this.userId;
    this._userService.updateUserPassword(this.changeUserPassword).subscribe(res => {
      var responseData = JSON.parse(res._body);
      if (responseData.isSuccess) {
        this.changeUserPassword = responseData.responseData;
        this.alertify.success(responseData.responseMessage);
        this.Loader = false;
        this.modalService.dismissAll();
      }
      else {
        this.alertify.error(responseData.responseMessage);
        this.Loader = false;
      }
    })
  }
}
